import DialogHeader from "./DialogHeader"
export default DialogHeader
